import {Box, SxProps, Typography} from '@mui/material';
import React, {FC, useLayoutEffect} from 'react';
import {FlexRow} from '../basic-flex/flex-row';
import { Colors } from 'shared/assets/root-assets/colors';
export const whiteColor = '#333333';
 const switchBoxShadow = '0px 1px 8px #0000001A';
 export const sidebarPopperBackground = '#FFFFFF';
type Props = {
  selectedValue?: string;
  options: {key: any; value: string}[];
  onChange: (key: any) => void;
};

export const isNullOrUndefined = (data: any) => {
  return data === undefined || data === null;
};

export function makeid() {
  let result = '';
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  let counter = 0;
  while (counter < 8) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
    counter += 1;
  }
  return result;
}

const localStyle: {[key: string]: SxProps} = {
  basicInputMarker: {
    backgroundColor: sidebarPopperBackground,
    position: 'absolute',
    height: '100%',
    transition: 'all 0.5s',
    borderRadius: 4,
  },
  optionContainer: {
    position: 'relative',
    backgroundColor: Colors.yellow,
    borderRadius: 10,
    overflow: 'hidden',
    width: 'fit-content',
    boxShadow: switchBoxShadow,
    zIndex: 1,
  },
  selectOption: {
    zIndex: 1,
    cursor: 'pointer',
    transition: 'all 1.0s',
    minWidth: '40px',
    display: 'block',
    userSelect: 'none',
    fontSize: 16,
    paddingTop: 1.5,
    paddingBottom: 1.5,
    paddingLeft: 3,
    paddingRight: 3,
  },

  switchNotSelected: {
    color: sidebarPopperBackground,
  },
  switchSelected: {
    color: whiteColor,
  },
};

export const BasicSwitch: FC<Props> = React.memo(({selectedValue, options, onChange}) => {
  const randomId = makeid(); // Handles multiple Basic switched, duo to getelement need to find a specific element
  useLayoutEffect(() => {
    // make sure font is loaded
    if (selectedValue && randomId) {
      // get marker element and selected element
      let marker = document.getElementById('basic-input-marker' + randomId);
      let element = document.getElementById('marker-selected' + randomId);

      const selectedWidth = element?.offsetWidth;
      const selectLeft = element?.offsetLeft;

      if (marker && !isNullOrUndefined(selectedWidth) && !isNullOrUndefined(selectLeft)) {
        // Sets width and left postion
        marker.style.width = selectedWidth! + 'px';
        marker.style.left = selectLeft! + 'px';
      }
    }
  }, [selectedValue, randomId, options]);

  return (
    <FlexRow sx={localStyle.optionContainer}>
      <Box sx={localStyle.basicInputMarker} id={'basic-input-marker' + randomId} />
      {options.map((option) => {
        const onSelect = () => {
          onChange(option.key);
        };
        return (
          <Typography
            key={option.key}
            id={
              option.key === selectedValue
                ? 'marker-selected' + randomId
                : option.key + 'marker-not-selected' + randomId
            }
            sx={
              [
                localStyle.selectOption,
                option.key !== selectedValue ? localStyle.switchNotSelected : localStyle.switchSelected,
              ] as SxProps
            }
            onClick={onSelect}>
            {option.value}
          </Typography>
        );
      })}
    </FlexRow>
  );
});
